import React from "react";
import styles from "./time-series-line-no-alarm-data.module.scss";
import { useI18N } from "@src/language/language-context";

const cssClassName = "time-series-line-no-alarm-data";

export const TimeSeriesLineNoAlarmData = () => {
  const i18n = useI18N();
  const texts = {
    noData: i18n("modules.timeSeriesLineNoData.noData"),
  };

  return <div className={styles[cssClassName]}>{texts.noData}</div>;
};
